import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE } from '../api-base.token';
import { OperatorRequest } from './operator-request';
import { OperatorResponse } from './operator-response';
import { GetOperatorWorkspacesResponse } from './get-operator-workspaces-response';

const path = 'operators';

@Injectable({
  providedIn: 'root',
})
export class OperatorsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get() {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.get<OperatorResponse[]>(url);
  }

  getById(operatorId: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${operatorId}`);

    return this.httpClient.get<OperatorResponse>(url);
  }

  post(operatorRequest: OperatorRequest) {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.post(url, operatorRequest);
  }

  update(memberId: string, operatorRequest: OperatorRequest) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${memberId}`);

    return this.httpClient.put(url, operatorRequest);
  }

  delete(operatorId: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${operatorId}`);

    return this.httpClient.delete(url);
  }

  exists(operatorId: string) {
    const url = Location.joinWithSlash(
      this.apiBase,
      `${path}/${operatorId}/exists`
    );

    return this.httpClient.get<boolean>(url);
  }

  getWorkspaces() {
    return this.httpClient.get<GetOperatorWorkspacesResponse>(
      `${this.apiBase}/operators/workspaces`
    );
  }
}
